var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",class:[_vm.is00 === 'is00' ? 'bgwhile' : _vm.is00 === 'is01' ? 'qianse' :
_vm.is00 === 'is02' ? 'baise' : _vm.is00 === 'is04' ? 'is04' : ''],style:({ color: _vm.color })},_vm._l((_vm.articleListlast),function(item){return _c('span',{staticClass:"oneHde",on:{"click":function($event){return _vm.toDetail(item.articleShortName)}}},[_vm._v("● "+_vm._s(item.articleTitle))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }